import QRCode from 'qrcode';

/**
 * QR modules for an EMVCo payload, rendered by our own SVG (never an HTML/SVG string from a
 * library or the API). Error correction M, as in the Flutter app's counter QR.
 */
export interface QrMatrix {
  size: number;
  /** Row-major, true = dark module. */
  dark: boolean[];
}

export function qrMatrix(payload: string): QrMatrix {
  const qr = QRCode.create(payload, { errorCorrectionLevel: 'M' });
  const size = qr.modules.size;
  const dark: boolean[] = new Array<boolean>(size * size);
  for (let i = 0; i < size * size; i += 1) dark[i] = qr.modules.data[i] === 1;
  return { size, dark };
}

/**
 * One SVG path for all dark modules (a 1×1 square each, horizontal runs merged), in module
 * coordinates offset by the quiet zone.
 */
export function qrPath(m: QrMatrix, quiet: number): string {
  const parts: string[] = [];
  for (let y = 0; y < m.size; y += 1) {
    let x = 0;
    while (x < m.size) {
      if (!m.dark[y * m.size + x]) {
        x += 1;
        continue;
      }
      let run = 1;
      while (x + run < m.size && m.dark[y * m.size + x + run]) run += 1;
      parts.push(`M${x + quiet} ${y + quiet}h${run}v1h-${run}z`);
      x += run;
    }
  }
  return parts.join('');
}
